import React from "react";
import { useTranslation } from "react-i18next";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const [t] = useTranslation();
  // Helper function to generate page numbers
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      // Show all pages if total pages are 5 or less
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show first, last, and middle dots
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  let isPrevDisable = currentPage === 1;
  let isNextDisable = currentPage === totalPages;

  return (
    <div className="flex flex-col justify-center items-center gap-[10px] self-stretch">
      <div className="flex gap-[4px] rounded-[8px] bg-white">
        <div
          className={`flex py-[10px] px-[16px] justify-center items-center gap-[8px] ${
            isPrevDisable ? "cursor-none" : " cursor-pointer"
          }`}
        >
          <span
            className={`w-[20px] h-[20px] text-[20px] mt-[-9px] ${
              isPrevDisable ? "text-default-color" : "text-gray-[900]"
            }  `}
          >
            {"<"}
          </span>

          <div
            className={`${
              isPrevDisable
                ? "text-default-color cursor-none"
                : "text-gray-900 cursor-pointer"
            } text-[16px] font-semibold`}
            onClick={() => {
              if (isPrevDisable) {
                return;
              }
              onPageChange(currentPage - 1);
            }}
          >
            {t("Previous")}
          </div>
        </div>

        {getPageNumbers().map((page, index) =>
          typeof page === "number" ? (
            <button
              key={index}
              onClick={() => {
                onPageChange(page);
              }}
              className={`px-3 w-[40px] py-2 border rounded-[8px]  ${
                page === currentPage
                  ? "border-[1px] border-solid border-[#ABE3FB] bg-light-primary text-dark-primary text-[16px] font-medium"
                  : "bg-[#F7F8F8] text-gray-900 text-[16px] font-medium border-none"
              }`}
            >
              {page}
            </button>
          ) : (
            <span key={index} className="px-3 py-2 text-gray-500">
              ...
            </span>
          )
        )}

        <div
          className={`flex py-[10px] px-[16px] justify-center items-center gap-[8px] ${
            isNextDisable ? "cursor-none" : " cursor-pointer"
          }`}
        >
          <div
            className={`${
              isNextDisable ? "text-default-color" : "text-gray-900"
            } text-[16px] font-semibold`}
            onClick={() => {
              if (isNextDisable) {
                return;
              }
              onPageChange(currentPage + 1);
            }}
          >
            {t("Next")}
          </div>

          <span
            className={`w-[20px] h-[20px] text-[20px] mt-[-9px] text-end ${
              isNextDisable ? "text-default-color" : "text-gray-[900]"
            }  `}
          >
            {">"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
